import { getJson } from "./apiClient";
import { normalizeProduct } from "../models/product.model";

/**
 * @param {{
 *  lang?: string,
 *  onlyActive?: boolean,
 *  categoryId?: number|null
 * }} [opts]
 */
export async function fetchProducts(opts = {}) {
  const { lang = "ar", onlyActive = true, categoryId = null } = opts;

  // Endpoint: /api/Products?lang=ar
  const data = await getJson("/api/Products", { lang });

  let list = Array.isArray(data) ? data.map(normalizeProduct) : [];

  if (onlyActive) list = list.filter((p) => p.isActive);
  if (categoryId) list = list.filter((p) => p.categoryId === Number(categoryId));

  // ترتيب حسب displayOrder ثم الاسم
  list.sort((a, b) => (a.displayOrder - b.displayOrder) || a.name.localeCompare(b.name, "ar"));

  return list;
}
